import { TravelerSelectors } from "@checkout/states";
import * as ApacSelectors from "./selectors";

export * from "./guards";
export {
  Services as ContactAndTravelerServices,
  ServiceTypes as ContactAndTravelerServiceTypes,
} from "./services";
export * from "./machine";
export * from "./types";
export * from "./context";
export { ContactAndTravelerInformationEventTypes } from "./types";
export {
  actions as ContactAndTravelerActions,
  ActionTypes as ContactAndTravelerActionsTypes,
} from "./actions";

export { Guards as ContactAndTravelerGuards } from "./guards";

const ContactAndTravelerSelectors = {
  ...TravelerSelectors,
  ...ApacSelectors,
};

export { ContactAndTravelerSelectors };
